export default {
    namespaced: true,
    state: {
      selectedFilters: {
        productTypes: [],
        attributes: [],
        availability: [],
        countries: [],
        regions: [],
        availabilityStatus: ["AVAILABLE", "UPCOMING"],
        minPrice: null,
        maxPrice: null,
      },
    },
    mutations: {
      SET_SELECTED_FILTERS(state, filters) {
        state.selectedFilters = filters;
      },
      RESET_FILTERS(state) {
        state.selectedFilters.productTypes = [];
        state.selectedFilters.attributes = [];
        state.selectedFilters.availability = ["IP", "SAQ", "MERCH_MTL", "Brouhh", 'BERGEVILLE'];
        state.selectedFilters.availabilityStatus = ["AVAILABLE", "UPCOMING"];
        state.selectedFilters.countries = [];
        state.selectedFilters.regions = [];
        state.selectedFilters.minPrice = null;
        state.selectedFilters.maxPrice = null;
      },
    },
    actions: {
      setSelectedFilters({ commit }, filters) {
        commit('SET_SELECTED_FILTERS', filters);
      },
      // resetFilters({ commit }) {
      //   commit("RESET_FILTERS");
      // },
    },
    getters: {
      getSelectedFilters(state) {
        return state.selectedFilters;
      },
    },
  };
  